import type { UIStrings } from './en';

export const ja: UIStrings = {
  'site.title': 'DopeJs — AI ネイティブ開発のためのオープンソースツール',
  'site.description':
    'DopeJs は AI ネイティブな開発のためのオープンソースツールを開発しています。エージェントランタイム、ターミナル向けコーディングエージェント、CLI 環境ツール、Canvas レンダリングエンジン。',

  'nav.projects': 'プロジェクト',
  'nav.about': 'について',
  'nav.github': 'GitHub',
  'nav.skip': '本文へスキップ',
  'nav.theme': 'テーマ',
  'nav.language': '言語',

  'hero.eyebrow': 'オープンソース · 公開開発',
  'hero.title': 'AI ネイティブ開発のためのツール。',
  'hero.body':
    'DopeJs は、ひとつの問いを軸にした小さなオープンソースプロジェクト群です。エージェントが開発ループの一部になったとき、毎日使うソフトウェアはどうあるべきか。エージェントランタイム、ターミナル向けコーディングエージェント、CLI 環境ツール、Canvas レンダリングエンジン — すべて公開の場で開発しています。',
  'hero.cta.projects': 'プロジェクトを見る',
  'hero.cta.github': 'GitHub で見る',
  'hero.count': '個のプロジェクト',

  'projects.title': 'プロジェクト',
  'projects.repo': 'リポジトリ',
  'projects.homepage': '公式サイト',
  'projects.install': 'インストール',
  'projects.copy': 'コピー',
  'projects.copied': 'コピーしました',
  'projects.details': '詳細',

  'status.stable': 'リリース済み',
  'status.active': '活発に開発中',
  'status.early': '初期段階 — 本番利用は不可',
  'status.design': '設計段階',

  'project.back': 'すべてのプロジェクト',
  'project.overview': '概要',
  'project.highlights': 'できること',
  'project.getStarted': '使い始める',
  'project.requirements': '動作要件',
  'project.facts': '基本情報',
  'project.facts.status': 'ステータス',
  'project.facts.languages': '言語',
  'project.facts.license': 'ライセンス',
  'project.facts.noLicense': 'まだなし',
  'project.links': 'リンク',
  'project.issues': 'Issues',
  'project.releases': 'Releases',
  'project.prev': '前へ',
  'project.next': '次へ',

  'about.title': 'DopeJs について',
  'about.body':
    'ここにあるものはすべて GitHub 上で公開開発されています。どのリポジトリでも Issue と Pull Request を歓迎します。「まだ動かない」という率直な報告も同じく歓迎です。いくつかのプロジェクトは意図的にプレリリース段階にあり、その場合はプロジェクト自身が明示しています。',
  'about.cta': 'GitHub で組織をフォローする',

  'footer.built': 'React と Vite で構築。ソースは GitHub にあります。',
  'footer.rights': 'DopeJs',
  'footer.translations': '翻訳は機械生成です。修正の提案を歓迎します。',
};
